import { Box, Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { Footer } from 'ui-components';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const defaultProps = {
  children: null,
};

const LayoutAnonymous = ({ children, ...props }) => {
  return (
    <Flex
      backgroundColor="gray.200"
      height={{ md: '100%' }}
      overflowX="hidden"
      minHeight="100vh"
      flexDirection="column"
      {...props}
    >
      <Box
        flex="1"
        as="main"
        maxWidth={1080}
        marginX="auto"
        paddingY={{ base: 5, sm: 8 }}
        paddingX={['0', '2', '4', '4', '0']}
        width="100%"
      >
        {children}
      </Box>
      <Box backgroundColor="white">
        <Footer />
      </Box>
    </Flex>
  );
};

LayoutAnonymous.propTypes = propTypes;
LayoutAnonymous.defaultProps = defaultProps;

export default LayoutAnonymous;
